import React from 'react';
import { Star } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

export default function AdminTestimonials() {
  return (
    <AdminCRUD
      endpoint="testimonials"
      title="Testimonials"
      icon={Star}
      columns={[
        { key:'name', label:'Person', render:(v,item) => (
          <div className="flex items-center gap-3">
            {item.avatar
              ? <img src={item.avatar} alt={v} className="w-9 h-9 rounded-full object-cover flex-shrink-0" />
              : <div className="w-9 h-9 rounded-full bg-royal-800 flex items-center justify-center text-white text-sm font-bold flex-shrink-0">{v?.[0]}</div>}
            <div>
              <div className="font-semibold text-gray-900 text-sm">{v}</div>
              <div className="text-xs text-gray-400">{item.role}{item.organization ? `, ${item.organization}` : ''}</div>
            </div>
          </div>
        )},
        { key:'content', label:'Quote', render: v => <span className="text-xs text-gray-500 line-clamp-2 max-w-xs block">{v}</span> },
        { key:'rating', label:'Rating', render: v => <span className="text-gold-500">{'★'.repeat(v||5)}</span> },
        { key:'isPublished', label:'Live', render: v => v ? <span className="text-emerald-500 font-bold">✓</span> : <span className="text-gray-300">—</span> },
        { key:'isFeatured', label:'Featured', render: v => v ? <span className="text-gold-500 font-bold">★</span> : <span className="text-gray-300">—</span> },
      ]}
      defaultForm={{ name:'', role:'', organization:'', avatar:'', content:'', rating:5, isPublished:true, isFeatured:false }}
      formFields={[
        { key:'avatar', label:'Photo', type:'image', fullWidth:true },
        { key:'name', label:'Full Name', required:true },
        { key:'role', label:'Role / Title' },
        { key:'organization', label:'Organization' },
        { key:'rating', label:'Rating', type:'select', options:[{value:5,label:'★★★★★ (5)'},{value:4,label:'★★★★ (4)'},{value:3,label:'★★★ (3)'}] },
        { key:'content', label:'Testimonial', type:'textarea', fullWidth:true, required:true, rows:4 },
        { key:'isPublished', label:'Publish', type:'checkbox', checkLabel:'Show on website', fullWidth:true },
        { key:'isFeatured', label:'Feature', type:'checkbox', checkLabel:'Feature on homepage', fullWidth:true },
      ]}
    />
  );
}
